import { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { blacklistaddress, unblacklistaddress } from "../Web3/Methods";
import { tokenAddress } from "../Web3/Constents";

export default function Blacklist({ selectedToken: parentSelectedToken = "ICUSD" }) {
  const [blacklist, setBlacklist] = useState("");
  const [unblacklist, setUnBlacklist] = useState("");
  const [selectedToken, setSelectedToken] = useState(parentSelectedToken);

  // Sync with parent's selected token
  useEffect(() => {
    setSelectedToken(parentSelectedToken);
  }, [parentSelectedToken]);

  const error = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);

  const addtoblacklist = async () => {
    try {
      const data = await blacklistaddress(blacklist, selectedToken);
      if (data.status) {
        sucess("Blacklisted Successfully");
      } else {
        error("Could not Blacklist");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removetoblacklist = async () => {
    try {
      const data = await unblacklistaddress(unblacklist, selectedToken);
      if (data.status) {
        sucess("Removed Successfully");
      } else {
        error("Could not Remove Blacklist");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" blacklist-main my-5">
      <Toaster />
      {/* <h3>CONTRACT IS PAUSED</h3> */}
      <div className="row my-5">
        <div className="col-md-6">
          <Form>
            <Form.Group className="mb-3" controlId="formBlacklist">
              <Form.Control
                type="text"
                placeholder="address"
                value={blacklist}
                onChange={(e) => setBlacklist(e.target.value)}
              />
            </Form.Group>
            <Button
              variant="primary"
              type="button"
              onClick={() => addtoblacklist()}
            >
              Freeze
            </Button>
          </Form>
        </div>

        <div className="col-md-6 my-4 my-md-0">
          <Form>
            <Form.Group className="mb-3" controlId="formRemoveBlacklist">
              <Form.Control
                type="text"
                placeholder="address"
                value={unblacklist}
                onChange={(e) => setUnBlacklist(e.target.value)}
              />
            </Form.Group>
            <Button
              variant="primary"
              type="button"
              onClick={() => removetoblacklist()}
            >
              Unfreeze
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
